import turfArea from 'turf-area';
import bboxPolygon from 'turf-bbox-polygon';
import map from '../map';
import {controlsModel} from '../controls';

// calculate areas on initial map load, and any move/zoom/rotate, etc.
['load', 'moveend'].forEach(function(e){
    map.on(e, function(){
        calculateViewportArea();
    });
});

/**
 * calculate the bounding box area and update the vue model
 */
export function calculateViewportArea() {
    let b = map.getBounds();
    // create polygon of bounding box [xLow, yLow,  xHigh, yHigh]
    let boundsPolygon = bboxPolygon([b._sw.lng, b._sw.lat, b._ne.lng, b._ne.lat]);
    // calculate area of polygon
    controlsModel.visibleExtent = turfArea(boundsPolygon) / 1000000; // m² to km²
}

/**
 * calculate visible areas for each layer and update the vue model
 * @param  {object} areas object with total number of features per layer
 */
export function calculateVisibleAreas(areas) {
    let zoom = map.getZoom();
    for (let layer in areas) {
        if (areas.hasOwnProperty(layer)) {
            controlsModel.areas[layer] = calculateArea(areas[layer], zoom);
        }
    }
}

/**
 * Calculate area based on zoom level and number of features
 * @param  {integer} numDots   number of dot features on this layer
 * @param  {float} zoomLevel map zoom level
 * @return {float}           area in km²
 */
function calculateArea(numDots, zoomLevel) {
    // points don't change after 14, so use 14 for higher zooms
    if (zoomLevel > 14) {
        zoomLevel = 14;
    }

    // formula: area = 100 * 3 ^ (14 - zoom)
    const zoomFactor = 14 - Math.floor(zoomLevel); // integer zoom level
    const areaMultiplier = 100 * Math.pow(3, zoomFactor);

    let area = numDots * areaMultiplier;
    area = area / 1000000; // m² to km²

    return area;
}



// WEBPACK FOOTER //
// ./src/js/area/area.js